import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  lng: "en", // Default language
  resources: {
    en: {
      translation: {
        MemberScince: "Member Scince",
        PersonalDetails: "PersonalDetails",
        Birthday: "Birthday",
        YearsOld: "Years old",

        Dashboard: "Dashboard",
        Inquiry: "Inquiry",
        InquiryList: "Inquiry List",
        AddInquiry: "Add Inquiry",
        Membership: "Membership",
        MemberList: "Member List",
        Member: "Member",
        AddMember: "Add Member",
        FreezeList: "Freeze List",
        AddFreeze: "Add Freeze",
        MeasurementList: "Measurement List",
        AddMeasurement: "Add Measurement",
        Payment: "Payment",
        PaymentList: "Payment List",
        AddPayment: "Add Payment",
        Invoice: "Invoice",
        CreateDate: "Create Date",
        CreateUser: "Create User",
        PayNow: "Pay Now",
        PaymentId: "Payment Id",
        ViewFile: "View File",
        InvoiceList: "Invoice List",
        AddInvoice: "Add Invoice",
        Attendance: "Attendance",
        Master: "Master",
        UserList: "User List",
        AddUser: "Add User",
        BranchList: "Branch List",
        AddBranch: "Add Branch",
        City: "City",
        CityList: "City List",
        Types: "Types",
        ZIP: "ZIP Code",
        Language: "Language",
        FollowUpTypes: "Follow Up Types",
        FollowUpType: "Follow Up Type",
        DefaultBranch: "Default Branch",
        SetDefaultBranch: "Set Default Branch",
        InquirySources: "Inquiry Sources",
        InquirySource: "Inquiry Source",
        MemberStatus: "Member Status",
        SubmitAsADefaultBranch: "Submit as a Default Branch",
        Organization: "Organization",
        SubscriptionTypes: "Subscription Types",
        SubscriptionPlans: "Subscription Plans",
        // Dashbaord
        PaymentsThisMonth: "PAYMENTS THIS MONTH",
        // Inner Text
        Scheduled: "Scheduled",
        Paid: "Paid",
        Overdue: "Overdue",
        Notification: "Notification",
        Payments: "Payments",
        // Status
        Pending: "Pending",
        Active: "Active",
        Expired: "Expired",
        Total: "Total",
        In: "In",
        Out: "Out",
        Due: "Due",
        NoPlan: "No Plan",
        Date: "Date",
        Thumb: "Thumb",
        InTime: "In Time",
        ThumbId: "Thumb Id",
        OutTime: "Out Time",
        UserId: "User Id",
        ExpiresIn: "Expires in",
        Days: "Days",
        LastVisit: "Last Visit",
        LastPaid: "Last Paid",
        Profile: "Profile",
        FreezeMember: "Freeze Member",
        UserDetails: "User Details",
        // Table Header
        Memeber: "Memeber",
        Contact: "Contact",
        BillingStatus: "Billing Status",
        MemberId: "Member Id",
        ChargeType: "Charge Type",
        PackageName: "Package Name",
        Amount: "Amount",
        Freeze: "Freeze",
        FreezeDate: "Freeze Date",
        Age: "Age",
        Height: "Height (Feet)",
        Weight: "Weight (KG)",
        PaymentMethod: "Payment Method",
        ReferenceNo: "Reference No.",
        PaymentDate: "Payment Date",
        Status: "Status",
        IdFreeFreeze: "Id / Free Freeze",
        DueAmount: "Due Amount",
        Subscription: "Subscription",
        Duration: "Duration",
        InvoiceId: "Invoice ID",
        PlanDate: "Plan Date",
        Id: "Id",
        Visit: "Visit",
        UploadFile: "Upload File",
        Package: "Package",
        PayDate: "Pay Date",
        Name: "Name",
        Phone: "Phone",
        Mobile: "Mobile",
        Gender: "Gender",
        Nationality: "Nationality",
        AlternateMobile: "Alternate Mobile",
        PrimaryAddress: "Primary Address",
        SecondaryAddress: "Secondary Address",
        ProfilePhoto: "Profile Photo",
        IDProof: "ID Proof",
        CivilId: "Civil Id",
        Remark: "Remark",
        User: "User",
        Username: "Username",
        Branch: "Branch",
        UserRole: "User Role",
        Address: "Address",
        Country: "Country",
        AddedDate: "Added Date",
        LastUpdateDate: "Last Update Date",
        AddedUser: "Added User",
        SubscriptionType: "Subscription Type",
        SubscriptionPlan: "Subscription Plan",
        FreeFreeze: "Free Freeze",
        InquirySourceName: "Inquiry Source Name",
        SourceOfInquiry: "Source of Inquiry",
        InquiryDate: "Inquiry Date",
        TypeName: "Type Name",
        InquiryId: "Inquiry Id",
        Add: "Add",
        Added: "Added",
        Edit: "Edit",
        Delete: "Delete",
        Update: "Update",
        Actions: "Actions",
        AddFollowUp: "Add Follow Up",
        AddFollowUpType: "Add Follow Up Type",
        FollowUpDate: "Follow Up Date",
        FollowUpTime: "Follow Up Time",
        Type: "Type",
        Note: "Note",
        FollowUp: "Follow Up",
        Successfully: "Successfully",
        Success: "Success",
        Cancel: "Cancel",
        Submit: "Submit",
        Details: "Details",
        Discount: "Discount",
        Error: "Error",
        StopAccess: "Stop Access",
        NetPay: "Net Pay",
        Warning: "Warning",
        FreeFreezeCount: "Free Freeze Count",
        InvoiceTitle: "Invoice Title",
        FollowType: "Follow Type",
        AddInquirySource: "Add Inquiry Source",
        InquirySrouceName: "Inquiry Srouce Name",
        GenerateMemberId: "Generate Member Id",
        EnrollmentId: "Enrollment Id",
        DateOfBirth: "Date of Birth",
        Loading: "Loading",
        UnfreezeMember: "Unfreeze Member",
        View: "View",
        State: "State",
        Measurement: "Measurement",
        Freezed: "Freezed",
        StartDate: "Start Date",
        EndDate: "End Date",
        NotStartedYet: "Not started yet",
        WaveAmount: "WAVE AMOUNT",
        MemberDetails: "MemberDetails",
        PlanSubscribed: "Plan Subscribed",
        PlanEndDate: "Plan End Date",
        Unfreeze: "Unfreeze",
        Start: "Start",
        End: "End",
        LeanMuscle: "Lean Muscle",
        Neck: "Neck",
        NavelPoint: "Navel Point",
        RArm: "R Arm",
        LArm: "L Arm",
        LNavelPoint: "L Navel Point",
        ThighL: "Thigh L",
        ThighR: "Thigh R",
        ShoulderRound: "Shoulder (Round)",
        Chest: "Chest",
        UpperAbs: "Upper Abs",
        UpperWaist: "Upper Waist",
        LowerWaist: "Lower Waist",
        LCalves: "L Calves",
        RCalves: "R Calves",
        BMI: "BMI",
        BMR: "BMR",
        VisceralFat: "Visceral Fat",
        SubcutaneousFat: "Subcutaneous Fat",
        DoYouHave: "Do you have?",
        HeightFeet: "Height (Feet)",
        WeightKG: "Weight (KG)",
        CreateInvoice: "Create Invoice",
        DueDate: "Due Date",
        Title: "Title",
        Plan: "Plan",
        PaidDate: "Paid Date",
        Password: "Password",
        ConfirmPassword: "Confirm Password",
        Inactive: "Inactive",
        EditOrganizationDetails: "Edit Organization Details",
        OrganizationName: "Organization Name",
        LocaleOrgName: "Locale Org. Name",
        FreezeFees: "Freeze Fees",
        EnrollmentFees: "Enrollment Fees",
        TransferFees: "Transfer Fees",
        MachineIP: "Machine IP",
        ServerIP: "Server IP",
        TaxNo: "Tax No",
        AUTOEMAILSEND: "AUTO EMAIL SEND",
        BIOMETRIC_INTEGRATION: "BIOMETRIC INTEGRATION",
        Logo: "Logo",
        SubmitDifBranch: "Submit as a Default Branch",
        BranchDetails: "Branch Details",
        BranchId: "Branch Id",
        BranchName: "Branch Name",
        Currency: "Currency",
        FeezeFees: "Feeze Fees",
        Website: "Website",
        AutoEmailSend: "Auto Email Send",
        BiometricIntegration: "Biometric Integration",
        Yes: "Yes",
        Ok: "Ok",
        Welcome: "Welcome",
        MyAccount: "My Account",
        Logout: "Logout",

        // Form
        GeneralFields: "General Fields",
        AdditionalFields: "Additional Fields",
        SaveChanges: "Save Changes",
        FirstName: "First Name",
        LastName: "Last Name",
        Email: "Email",
        AddStatus: "Add Status",
        AddPlan: "Add Plan",
        AddCity: "Add City",

        // Alert
        CfmTitle: "Are you sure",
        DltSuccessTitle: "Deleted Successfully",
        MemberDltTitle: "You want to delete this member?",
        FollowUpDltTitle: "You want to delete this follow up?",
        FollowUpTypeDltTitle: "You want to delete this type?",
        InqDltTitle: "You want to delete this inquiry source?",
        MemberStatusDltTitle: "You want to delete this member status?",
        MMAddTitle: "Measurement Added Successfully.",
        MMDltTitle: "You want to delete this measurement?",
        PaymentSuccessTitle: "You have successfully paid.",
        InvSuccessTitle: "Invoice Created Successfully.",
        InvDltTitle: "You want to delete this user?",
        UserStatusChgMsg1: "You want to",
        UserStatusChgMsg2: "this user?",
        OrgSuccessTitle: "Organization data updated successfully.",
        SubsPlanDltTitle: "You want to delete this subscription plan?",
        SubsTypeDltTitle: "You want to delete this subscription type?",
        BranchDltTitle: "You want to delete this branch?",
        BranchDtlErrTitle:
          "You can't delete this branch, Because this is the selected branch right now.",
        BranchDltSuccessTitle: "Successfully set as a default Branch",
        DltErrTitle: "Something is wrong. Please try again.",
        CityDltTitle: "You want to delete this city?",
        DataNotAvaiable: "Data Not Avaiable",

        // Validation Messanges
        ValFollowUpDate: "Follow Up Date is required.",
        ValFollowUpTime: "Follow Up Time is required.",
        ValFollowUpType: "Type is required.",
        ValName: "Name is required",
        ValFirstName: "First Name is required",
        ValLastName: "Last Name is required",
        ValGender: "Gender is required",
        ValMobile: "Mobile is required",
        ValEmail: "Email is required",
        ValRole: "Role is required.",
        ValPass: "Password is required.",
        ValConfPass: "Confirm Password is required.",
        ValPassNotMatch: "Password and Confirm password not match",
        ValMemberId: "Member Id is required",
        ValCity: "City is required",
        ValDob: "Date of Birth is required",
        ValEnrollmentId: "Enrollment Id is required",
        ValMember: "Member is required.",
        ValStartDate: "Start date is required.",
        ValEndDate: "End date is required.",
        ValAmount: "Amount is required.",
        ValDate: "Date is required.",
        ValHeight: "Height is required.",
        ValWeight: "Weight is required.",
        ValPaymentMethod: "Payment method is required.",
        ValPaymentDate: "Payment date is required.",
        ValSubsType: "Subscription type is required.",
        ValSubsPlan: "Subscription plan is required.",
        ValDueDate: "Due date is required.",
        ValOrgName: "Org. name is required.",
        ValCountry: "Country is required.",
        ValPhone: "Phone is required.",
        ValState: "State is required.",
        ValZip: "ZIP is required.",
        ValAddress: "Address is required.",
        ValDuration: "Duration is required.",
        ValFreeze: "Freeze is required.",
        ValBranch: "Branch is required.",
        ValCurrency: "Currency is required.",

        // Custome Messages
        invHaveMsg1: "You have already",
        invHaveMsg2:
          "active invoice. Right now your creating invoice you'll start after end this invoice",
      },
    },
    ar: {
      translation: {
        MemberScince: "عضو منذ",
        PersonalDetails: "تفاصيل شخصية",
        Birthday: "تاريخ الميلاد",
        YearsOld: "سنوات",
        Search: "البحث",
        MakeMember: "إنشاء عضو",
        Dashboard: "لوحة القيادة",
        Inquiry: "استفسار",
        InquiryList: "قائمة الاستفسارات",
        AddInquiry: "إضافة استفسار",
        Membership: "العضوية",
        MemberList: "قائمة الأعضاء",
        Member: "عضو",
        AddMember: "إضافة عضو",
        FreezeList: "قائمة التجميد",
        AddFreeze: "إضافة تجميد",
        MeasurementList: "قائمة القياسات",
        AddMeasurement: "إضافة قياس",
        Payment: "الدفع",
        PaymentList: "قائمة الدفع",
        AddPayment: "إضافة دفع",
        Invoice: "الفاتورة",
        CreateDate: "تاريخ الإنشاء",
        CreateUser: "إنشاء المستخدم",
        PayNow: "الدفع الآن",
        PaymentId: "معرف الدفع",
        ViewFile: "عرض الملف",
        InvoiceList: "قائمة الفواتير",
        AddInvoice: "إضافة فاتورة",
        Attendance: "الحضور",
        Master: "الرئيسي",
        UserList: "قائمة المستخدمين",
        AddUser: "إضافة مستخدم",
        BranchList: "قائمة الفروع",
        AddBranch: "إضافة فرع",
        City: "المدينة",
        CityList: "قائمة المدن",
        Types: "الأنواع",
        ZIP: "الرمز البريدي",
        Language: "اللغة",
        FollowUpTypes: "أنواع المتابعة",
        FollowUpType: "نوع المتابعة",
        DefaultBranch: "الفرع الافتراضي",
        SetDefaultBranch: "تعيين الفرع الافتراضي",
        InquirySources: "مصادر الاستفسار",
        InquirySource: "مصدر الاستفسار",
        MemberStatus: "حالة العضو",
        SubmitAsADefaultBranch: "تقديم كفرع افتراضي",
        Organization: "المنظمة",
        SubscriptionTypes: "أنواع الاشتراك",
        SubscriptionPlans: "خطط الاشتراك",
        // Dashbaord
        PaymentsThisMonth: "المدفوعات هذا الشهر",
        // Inner Text
        Scheduled: "مجدول",
        Paid: "مدفوع",
        Overdue: "متأخر عن الدفع",
        Notification: "إشعار",
        Payments: "المدفوعات",
        // Status
        Pending: "قيد الانتظار",
        Active: "نشط",
        Expired: "منتهي الصلاحية",
        Total: "المجموع",
        In: "داخل",
        Out: "خارج",
        Due: "مستحق",
        NoPlan: "بدون خطة",
        Date: "تاريخ",
        Thumb: "بصمة الإبهام",
        InTime: "وقت الدخول",
        ThumbId: "معرف البصمة",
        OutTime: "وقت الخروج",
        UserId: "معرف المستخدم",
        ExpiresIn: "تنتهي صلاحيته في",
        Days: "أيام",
        LastVisit: "آخر زيارة",
        LastPaid: "آخر مدفوع",
        Profile: "الملف الشخصي",
        FreezeMember: "تجميد العضو",
        UserDetails: "تفاصيل المستخدم",
        // Table Header
        Memeber: "العضو",
        Contact: "الاتصال",
        BillingStatus: "حالة الفواتير",
        MemberId: "معرف العضو",
        ChargeType: "نوع الرسوم",
        PackageName: "اسم الحزمة",
        Amount: "المبلغ",
        Freeze: "تجميد",
        FreezeDate: "تاريخ التجميد",
        Age: "العمر",
        Height: "الطول (قدم)",
        Weight: "الوزن (كجم)",
        PaymentMethod: "طريقة الدفع",
        ReferenceNo: "الرقم المرجعي",
        PaymentDate: "تاريخ الدفع",
        Status: "الحالة",
        IdFreeFreeze: "المعرف / التجميد المجاني",
        DueAmount: "المبلغ المستحق",
        Subscription: "الاشتراك",
        Duration: "المدة",
        InvoiceId: "معرف الفاتورة",
        PlanDate: "تاريخ الخطة",
        Id: "المعرف",
        Visit: "الزيارة",
        UploadFile: "تحميل الملف",
        Package: "الحزمة",
        PayDate: "تاريخ الدفع",
        Name: "الاسم",
        Phone: "الهاتف",
        Mobile: "الجوال",
        Gender: "الجنس",
        Nationality: "الجنسية",
        AlternateMobile: "الجوال البديل",
        PrimaryAddress: "العنوان الرئيسي",
        SecondaryAddress: "العنوان الثانوي",
        ProfilePhoto: "صورة الملف الشخصي",
        IDProof: "إثبات الهوية",
        CivilId: "الهوية المدنية",
        Remark: "ملاحظة",
        User: "المستخدم",
        Username: "اسم المستخدم",
        Branch: "الفرع",
        UserRole: "دور المستخدم",
        Address: "العنوان",
        Country: "البلد",
        AddedDate: "تاريخ الإضافة",
        LastUpdateDate: "تاريخ آخر تحديث",
        AddedUser: "المستخدم المضاف",
        SubscriptionType: "نوع الاشتراك",
        SubscriptionPlan: "خطة الاشتراك",
        FreeFreeze: "تجميد مجاني",
        InquirySourceName: "اسم مصدر الاستفسار",
        SourceOfInquiry: "مصدر الاستفسار",
        InquiryDate: "تاريخ الاستفسار",
        TypeName: "اسم النوع",
        InquiryId: "معرف الاستفسار",
        Add: "إضافة",
        Added: "تمت الإضافة",
        Edit: "تعديل",
        Delete: "حذف",
        Update: "تحديث",
        Actions: "الإجراءات",
        AddFollowUp: "إضافة متابعة",
        AddFollowUpType: "إضافة نوع المتابعة",
        FollowUpDate: "تاريخ المتابعة",
        FollowUpTime: "وقت المتابعة",
        Type: "النوع",
        Note: "ملاحظة",
        FollowUp: "متابعة",
        Successfully: "بنجاح",
        Success: "نجاح",
        Cancel: "إلغاء",
        Submit: "إرسال",
        Details: "التفاصيل",
        Discount: "خصم",
        Error: "خطأ",
        StopAccess: "إيقاف الوصول",
        NetPay: "المبلغ الصافي",
        Warning: "تحذير",
        FreeFreezeCount: "عدد التجميد المجاني",
        InvoiceTitle: "عنوان الفاتورة",
        FollowType: "نوع المتابعة",
        AddInquirySource: "إضافة مصدر الاستفسار",
        InquirySrouceName: "اسم مصدر الاستفسار",
        GenerateMemberId: "إنشاء معرف العضو",
        EnrollmentId: "معرف التسجيل",
        DateOfBirth: "تاريخ الميلاد",
        Loading: "جاري التحميل",
        UnfreezeMember: "إلغاء تجميد العضو",
        View: "عرض",
        State: "الولاية",
        Measurement: "القياس",
        Freezed: "مجمد",
        StartDate: "تاريخ البدء",
        EndDate: "تاريخ الانتهاء",
        NotStartedYet: "لم يبدأ بعد",
        WaveAmount: "مبلغ الإشارة",
        MemberDetails: "تفاصيل العضو",
        PlanSubscribed: "الخطة المشتركة",
        PlanEndDate: "تاريخ انتهاء الخطة",
        Unfreeze: "إلغاء التجميد",
        Start: "بدء",
        End: "انتهاء",
        LeanMuscle: "العضلات الرقيقة",
        Neck: "الرقبة",
        NavelPoint: "نقطة السرة",
        RArm: "الذراع الأيمن",
        LArm: "الذراع الأيسر",
        LNavelPoint: "نقطة السرة اليسرى",
        ThighL: "الفخذ الأيسر",
        ThighR: "الفخذ الأيمن",
        ShoulderRound: "الكتف (مستدير)",
        Chest: "الصدر",
        UpperAbs: "البطن العلوي",
        UpperWaist: "الخصر العلوي",
        LowerWaist: "الخصر السفلي",
        LCalves: "الساق اليسرى",
        RCalves: "الساق اليمنى",
        BMI: "مؤشر كتلة الجسم",
        BMR: "معدل الأيض الأساسي",
        VisceralFat: "الدهون الحشوية",
        SubcutaneousFat: "الدهون تحت الجلد",
        DoYouHave: "هل تمتلك؟",
        HeightFeet: "الطول (قدم)",
        WeightKG: "الوزن (كجم)",
        CreateInvoice: "إنشاء فاتورة",
        DueDate: "تاريخ الاستحقاق",
        Title: "العنوان",
        Plan: "الخطة",
        PaidDate: "تاريخ الدفع",
        Password: "كلمة المرور",
        ConfirmPassword: "تأكيد كلمة المرور",
        Inactive: "غير نشط",
        EditOrganizationDetails: "تعديل تفاصيل المنظمة",
        OrganizationName: "اسم المنظمة",
        LocaleOrgName: "اسم المنظمة باللغة المحلية",
        FreezeFees: "رسوم التجميد",
        EnrollmentFees: "رسوم التسجيل",
        TransferFees: "رسوم النقل",
        MachineIP: "عنوان IP للجهاز",
        ServerIP: "عنوان IP للخادم",
        TaxNo: "رقم الضريبة",
        AUTOEMAILSEND: "إرسال البريد الإلكتروني تلقائيًا",
        BIOMETRIC_INTEGRATION: "تكامل بصمات الأصابع",
        Logo: "شعار",
        SubmitDifBranch: "تقديم كفرع افتراضي",
        BranchDetails: "تفاصيل الفرع",
        BranchId: "معرف الفرع",
        BranchName: "اسم الفرع",
        Currency: "العملة",
        FeezeFees: "رسوم التجميد",
        Website: "موقع الويب",
        AutoEmailSend: "إرسال البريد الإلكتروني تلقائيًا",
        BiometricIntegration: "تكامل بصمات الأصابع",
        Yes: "نعم",
        Ok: "موافق",

        // Form
        GeneralFields: "حقول عامة",
        AdditionalFields: "حقول إضافية",
        SaveChanges: "حفظ التغييرات",
        FirstName: "الاسم الأول",
        LastName: "اسم العائلة",
        Email: "البريد الإلكتروني",
        AddStatus: "إضافة حالة",
        AddPlan: "إضافة خطة",
        AddCity: "إضافة مدينة",

        // Alert
        CfmTitle: "هل أنت متأكد",
        DltSuccessTitle: "تم الحذف بنجاح",
        MemberDltTitle: "هل ترغب في حذف هذا العضو؟",
        FollowUpDltTitle: "هل ترغب في حذف هذا التتبع؟",
        FollowUpTypeDltTitle: "هل ترغب في حذف هذا النوع؟",
        InqDltTitle: "هل ترغب في حذف مصدر الاستفسار هذا؟",
        MemberStatusDltTitle: "هل ترغب في حذف حالة العضو هذه؟",
        MMAddTitle: "تمت إضافة القياس بنجاح.",
        MMDltTitle: "هل ترغب في حذف هذا القياس؟",
        PaymentSuccessTitle: "لقد قمت بالدفع بنجاح.",
        InvSuccessTitle: "تم إنشاء الفاتورة بنجاح.",
        InvDltTitle: "هل ترغب في حذف هذا المستخدم؟",
        UserStatusChgMsg1: "هل ترغب في",
        UserStatusChgMsg2: "هذا المستخدم؟",
        OrgSuccessTitle: "تم تحديث بيانات المنظمة بنجاح.",
        SubsPlanDltTitle: "هل ترغب في حذف هذه الخطة؟",
        SubsTypeDltTitle: "هل ترغب في حذف نوع الاشتراك هذا؟",
        BranchDltTitle: "هل ترغب في حذف هذا الفرع؟",
        BranchDtlErrTitle:
          "لا يمكنك حذف هذا الفرع، لأنه هو الفرع المحدد حاليًا.",
        BranchDltSuccessTitle: "تم تعيينه بنجاح كفرع افتراضي",
        DltErrTitle: "هناك خطأ ما. يرجى المحاولة مرة أخرى.",
        CityDltTitle: "هل ترغب في حذف هذه المدينة؟",

        // Validation Messages
        ValFollowUpDate: "تاريخ المتابعة مطلوب.",
        ValFollowUpTime: "وقت المتابعة مطلوب.",
        ValFollowUpType: "النوع مطلوب.",
        ValName: "الاسم مطلوب",
        ValFirstName: "الاسم الأول مطلوب",
        ValLastName: "اسم العائلة مطلوب",
        ValGender: "الجنس مطلوب",
        ValMobile: "الجوال مطلوب",
        ValEmail: "البريد الإلكتروني مطلوب",
        ValRole: "الدور مطلوب.",
        ValPass: "كلمة المرور مطلوبة.",
        ValConfPass: "تأكيد كلمة المرور مطلوب.",
        ValPassNotMatch: "كلمة المرور وتأكيد كلمة المرور غير متطابقين",
        ValMemberId: "معرف العضو مطلوب",
        ValCity: "المدينة مطلوبة",
        ValDob: "تاريخ الميلاد مطلوب",
        ValEnrollmentId: "معرف التسجيل مطلوب",
        ValMember: "العضو مطلوب.",
        ValStartDate: "تاريخ البدء مطلوب.",
        ValEndDate: "تاريخ الانتهاء مطلوب.",
        ValAmount: "المبلغ مطلوب.",
        ValDate: "التاريخ مطلوب.",
        ValHeight: "الطول مطلوب.",
        ValWeight: "الوزن مطلوب.",
        ValPaymentMethod: "طريقة الدفع مطلوبة.",
        ValPaymentDate: "تاريخ الدفع مطلوب.",
        ValSubsType: "نوع الاشتراك مطلوب.",
        ValSubsPlan: "خطة الاشتراك مطلوبة.",
        ValDueDate: "تاريخ الاستحقاق مطلوب.",
        ValOrgName: "اسم المنظمة مطلوب.",
        ValCountry: "البلد مطلوب.",
        ValPhone: "الهاتف مطلوب.",
        ValState: "الولاية مطلوبة.",
        ValZip: "الرمز البريدي مطلوب.",
        ValAddress: "العنوان مطلوب.",
        ValDuration: "المدة مطلوبة.",
        ValFreeze: "التجميد مطلوب.",
        ValBranch: "الفرع مطلوب.",
        ValCurrency: "العملة مطلوبة.",
        // Custom Messages
        invHaveMsg1: "لديك بالفعل",
        invHaveMsg2:
          "فاتورة نشطة. في الوقت الحالي، ستبدأ بعد انتهاء هذه الفاتورة",

        DataNotAvaiable: "البيانات غير متاحة",
        Welcome: "مرحبًا",
        MyAccount: "حسابي",
        Logout: "تسجيل الخروج",
      },
    },
    hi: {
      translation: {
        MemberScince: "सदस्य बने हुए",
        PersonalDetails: "व्यक्तिगत विवरण",
        Birthday: "जन्मदिन",
        YearsOld: "साल",
        Search: "खोज",
        MakeMember: "सदस्य बनाएं",
        Dashboard: "डैशबोर्ड",
        Inquiry: "पूछताछ",
        InquiryList: "पूछताछ सूची",
        AddInquiry: "पूछताछ जोड़ें",
        Membership: "सदस्यता",
        MemberList: "सदस्य सूची",
        Member: "सदस्य",
        AddMember: "सदस्य जोड़ें",
        FreezeList: "फ्रीज सूची",
        AddFreeze: "फ्रीज जोड़ें",
        MeasurementList: "मापन सूची",
        AddMeasurement: "मापन जोड़ें",
        Payment: "भुगतान",
        PaymentList: "भुगतान सूची",
        AddPayment: "भुगतान जोड़ें",
        Invoice: "चालान",
        CreateDate: "तिथि बनाएं",
        CreateUser: "उपयोगकर्ता बनाएं",
        PayNow: "अब भुगतान करें",
        PaymentId: "भुगतान आईडी",
        ViewFile: "फ़ाइल देखें",
        InvoiceList: "चालान सूची",
        AddInvoice: "चालान जोड़ें",
        Attendance: "उपस्थिति",
        Master: "मास्टर",
        UserList: "उपयोगकर्ता सूची",
        AddUser: "उपयोगकर्ता जोड़ें",
        BranchList: "शाखा सूची",
        AddBranch: "शाखा जोड़ें",
        City: "शहर",
        CityList: "शहर सूची",
        Types: "प्रकार",
        ZIP: "पिन कोड",
        Language: "भाषा",
        FollowUpTypes: "फ़ॉलो अप प्रकार",
        FollowUpType: "फ़ॉलो अप प्रकार",
        DefaultBranch: "डिफ़ॉल्ट शाखा",
        SetDefaultBranch: "डिफ़ॉल्ट शाखा सेट करें",
        InquirySources: "पूछताछ स्रोत",
        InquirySource: "पूछताछ स्रोत",
        MemberStatus: "सदस्य स्थिति",
        SubmitAsADefaultBranch: "डिफ़ॉल्ट शाखा के रूप में सबमिट करें",
        Organization: "संगठन",
        SubscriptionTypes: "सदस्यता प्रकार",
        SubscriptionPlans: "सदस्यता योजनाएँ",
        // Dashbaord
        PaymentsThisMonth: "इस महीने के भुगतान",
        // Inner Text
        Scheduled: "अनुसूचित",
        Paid: "भुगतान किया हुआ",
        Overdue: "समय से बाद",
        Notification: "सूचना",
        Payments: "भुगतान",
        // Status
        Pending: "अपूर्ण",
        Active: "सक्रिय",
        Expired: "समय समाप्त हो गया",
        Total: "कुल",
        In: "इन",
        Out: "आउट",
        Due: "बकाया",
        NoPlan: "कोई योजना नहीं",
        Date: "तिथि",
        Thumb: "अंगूठा",
        InTime: "अंदर का समय",
        ThumbId: "अंगूठा आईडी",
        OutTime: "बाहर का समय",
        UserId: "उपयोगकर्ता आईडी",
        ExpiresIn: "समय समाप्त होने में",
        Days: "दिन",
        LastVisit: "अंतिम दौरा",
        LastPaid: "अंतिम भुगतान",
        Profile: "प्रोफ़ाइल",
        FreezeMember: "सदस्य को फ्रीज करें",
        UserDetails: "उपयोगकर्ता विवरण",
        // Table Header
        Memeber: "सदस्य",
        Contact: "संपर्क",
        BillingStatus: "बिलिंग स्थिति",
        MemberId: "सदस्य आईडी",
        ChargeType: "शुल्क प्रकार",
        PackageName: "पैकेज का नाम",
        Amount: "राशि",
        Freeze: "फ्रीज",
        FreezeDate: "फ्रीज तिथि",
        Age: "आयु",
        Height: "ऊँचाई (फीट)",
        Weight: "वजन (किग्रा)",
        PaymentMethod: "भुगतान का तरीका",
        ReferenceNo: "संदर्भ संख्या",
        PaymentDate: "भुगतान तिथि",
        Status: "स्थिति",
        IdFreeFreeze: "आईडी / फ्री फ्रीज",
        DueAmount: "बकाया राशि",
        Subscription: "सदस्यता",
        Duration: "अवधि",
        InvoiceId: "चालान आईडी",
        PlanDate: "योजना तिथि",
        Id: "आईडी",
        Visit: "दौरा",
        UploadFile: "फ़ाइल अपलोड करें",
        Package: "पैकेज",
        PayDate: "भुगतान तिथि",
        Name: "नाम",
        Phone: "फ़ोन",
        Mobile: "मोबाइल",
        Gender: "लिंग",
        Nationality: "राष्ट्रीयता",
        AlternateMobile: "वैकल्पिक मोबाइल",
        PrimaryAddress: "प्राथमिक पता",
        SecondaryAddress: "माध्यमिक पता",
        ProfilePhoto: "प्रोफ़ाइल फोटो",
        IDProof: "आईडी प्रूफ",
        CivilId: "नागरिक आईडी",
        Remark: "टिप्पणी",
        User: "उपयोगकर्ता",
        Username: "उपयोगकर्ता नाम",
        Branch: "शाखा",
        UserRole: "उपयोगकर्ता भूमिका",
        Address: "पता",
        Country: "देश",
        AddedDate: "जोड़ी गई तिथि",
        LastUpdateDate: "अंतिम अद्यतन तिथि",
        AddedUser: "जोड़ने वाला उपयोगकर्ता",
        SubscriptionType: "सदस्यता प्रकार",
        SubscriptionPlan: "सदस्यता योजना",
        FreeFreeze: "मुफ्त फ्रीज",
        InquirySourceName: "पूछताछ स्रोत का नाम",
        SourceOfInquiry: "पूछताछ का स्रोत",
        InquiryDate: "पूछताछ तिथि",
        TypeName: "प्रकार का नाम",
        InquiryId: "पूछताछ आईडी",
        Add: "जोड़ें",
        Added: "जोड़ा गया",
        Edit: "संपादित करें",
        Delete: "हटाएं",
        Update: "अपडेट करें",
        Actions: "क्रियाएँ",
        AddFollowUp: "फ़ॉलो अप जोड़ें",
        AddFollowUpType: "फ़ॉलो अप प्रकार जोड़ें",
        FollowUpDate: "फ़ॉलो अप तिथि",
        FollowUpTime: "फ़ॉलो अप समय",
        Type: "प्रकार",
        Note: "टिप्पणी",
        FollowUp: "फ़ॉलो अप",
        Successfully: "सफलतापूर्वक",
        Success: "सफलता",
        Cancel: "रद्द करें",
        Submit: "प्रस्तुत करें",
        Details: "विवरण",
        Discount: "छूट",
        Error: "त्रुटि",
        StopAccess: "पहुंच बंद करें",
        NetPay: "कुल भुगतान",
        Warning: "चेतावनी",
        FreeFreezeCount: "मुफ्त फ्रीज गणना",
        InvoiceTitle: "चालान शीर्षक",
        FollowType: "फ़ॉलो अप प्रकार",
        AddInquirySource: "पूछताछ स्रोत जोड़ें",
        InquirySrouceName: "पूछताछ स्रोत का नाम",
        GenerateMemberId: "सदस्य आईडी बनाएं",
        EnrollmentId: "पंजीकरण आईडी",
        DateOfBirth: "जन्म तिथि",
        Loading: "लोड हो रहा है",
        UnfreezeMember: "सदस्य को अनफ़्रीज करें",
        View: "देखें",
        State: "राज्य",
        Measurement: "मापन",
        Freezed: "फ्रीज़ हो गया",
        StartDate: "प्रारंभ तिथि",
        EndDate: "समापन तिथि",
        NotStartedYet: "अब तक शुरू नहीं हुआ",
        WaveAmount: "वेव राशि",
        MemberDetails: "सदस्य विवरण",
        PlanSubscribed: "सदस्यता योजना सब्सक्राइब की गई",
        PlanEndDate: "योजना समापन तिथि",
        Unfreeze: "अनफ़्रीज",
        Start: "प्रारंभ",
        End: "समाप्त",
        LeanMuscle: "लीन मसल",
        Neck: "गर्दन",
        NavelPoint: "नाभि बिंदु",
        RArm: "दाईं हाथ",
        LArm: "बाईं हाथ",
        LNavelPoint: "बाईं नाभि बिंदु",
        ThighL: "बाईं जांघ",
        ThighR: "दाईं जांघ",
        ShoulderRound: "कंधा (गोल)",
        Chest: "छाती",
        UpperAbs: "ऊपरी पेट",
        UpperWaist: "ऊपरी कमर",
        LowerWaist: "निचली कमर",
        LCalves: "बाईं अड़छियाँ",
        RCalves: "दाईं अड़छियाँ",
        BMI: "बीएमआई",
        BMR: "बीएमआर",
        VisceralFat: "अंतर्दाहिक चर्बी",
        SubcutaneousFat: "उपकुटीय चर्बी",
        DoYouHave: "क्या आपके पास है?",
        HeightFeet: "ऊँचाई (फीट)",
        WeightKG: "वजन (किग्रा)",
        CreateInvoice: "चालान बनाएं",
        DueDate: "बकाया तिथि",
        Title: "शीर्षक",
        Plan: "योजना",
        PaidDate: "भुगतान तिथि",
        Password: "पासवर्ड",
        ConfirmPassword: "पासवर्ड की पुष्टि करें",
        Inactive: "निष्क्रिय",
        EditOrganizationDetails: "संगठन विवरण संपादित करें",
        OrganizationName: "संगठन का नाम",
        LocaleOrgName: "स्थानिक संगठन नाम",
        FreezeFees: "फ्रीज शुल्क",
        EnrollmentFees: "पंजीकरण शुल्क",
        TransferFees: "स्थानांतरण शुल्क",
        MachineIP: "मशीन आईपी",
        ServerIP: "सर्वर आईपी",
        TaxNo: "कर संख्या",
        AUTOEMAILSEND: "स्वच्छंद ईमेल भेजें",
        BIOMETRIC_INTEGRATION: "जैववैद्यक संघटन",
        Logo: "लोगो",
        SubmitDifBranch: "डिफ़ॉल्ट शाखा के रूप में सबमिट करें",
        BranchDetails: "शाखा विवरण",
        BranchId: "शाखा आईडी",
        BranchName: "शाखा का नाम",
        Currency: "मुद्रा",
        FeezeFees: "फीज शुल्क",
        Website: "वेबसाइट",
        AutoEmailSend: "स्वच्छंद ईमेल भेजें",
        BiometricIntegration: "जैववैद्यक संघटन",
        Yes: "हां",
        Ok: "ठीक है",
        // Form
        GeneralFields: "सामान्य क्षेत्र",
        AdditionalFields: "अतिरिक्त क्षेत्र",
        SaveChanges: "परिवर्तन सहेजें",
        FirstName: "पहला नाम",
        LastName: "उपनाम",
        Email: "ईमेल",
        AddStatus: "स्थिति जोड़ें",
        AddPlan: "योजना जोड़ें",
        AddCity: "शहर जोड़ें",
        // Alert
        CfmTitle: "क्या आपको यकीं है",
        DltSuccessTitle: "सफलतापूर्वक हटाया गया",
        MemberDltTitle: "क्या आप इस सदस्य को हटाना चाहते हैं?",
        FollowUpDltTitle: "क्या आप इस फ़ॉलो अप को हटाना चाहते हैं?",
        FollowUpTypeDltTitle: "क्या आप इस प्रकार को हटाना चाहते हैं?",
        InqDltTitle: "क्या आप इस पूछताछ स्रोत को हटाना चाहते हैं?",
        MemberStatusDltTitle: "क्या आप इस सदस्य स्थिति को हटाना चाहते हैं?",
        MMAddTitle: "मापन सफलतापूर्वक जोड़ा गया।",
        MMDltTitle: "क्या आप इस मापन को हटाना चाहते हैं?",
        PaymentSuccessTitle: "आपने सफलतापूर्वक भुगतान किया है।",
        InvSuccessTitle: "चालान सफलतापूर्वक बनाया गया।",
        InvDltTitle: "क्या आप इस उपयोगकर्ता को हटाना चाहते हैं?",
        UserStatusChgMsg1: "क्या आप",
        UserStatusChgMsg2: "इस उपयोगकर्ता को?",
        OrgSuccessTitle: "संगठन डेटा सफलतापूर्वक अपडेट किया गया।",
        SubsPlanDltTitle: "क्या आप इस सदस्यता योजना को हटाना चाहते हैं?",
        SubsTypeDltTitle: "क्या आप इस सदस्यता प्रकार को हटाना चाहते हैं?",
        BranchDltTitle: "क्या आप इस शाखा को हटाना चाहते हैं?",
        BranchDtlErrTitle:
          "आप इस शाखा को हटा नहीं सकते, क्योंकि यह वर्तमान में चयनित शाखा है।",
        BranchDltSuccessTitle:
          "सफलतापूर्वक डिफ़ॉल्ट शाखा के रूप में सेट किया गया",
        DltErrTitle: "कुछ गड़बड़ है। कृपया पुन: प्रयास करें।",
        CityDltTitle: "क्या आप इस शहर को हटाना चाहते हैं?",
        // Validation Messanges
        ValFollowUpDate: "फ़ॉलो अप तिथि आवश्यक है।",
        ValFollowUpTime: "फ़ॉलो अप समय आवश्यक है।",
        ValFollowUpType: "प्रकार आवश्यक है।",
        ValName: "नाम आवश्यक है",
        ValFirstName: "पहला नाम आवश्यक है",
        ValLastName: "उपनाम आवश्यक है",
        ValGender: "लिंग आवश्यक है",
        ValMobile: "मोबाइल आवश्यक है",
        ValEmail: "ईमेल आवश्यक है",
        ValRole: "भूमिका आवश्यक है।",
        ValPass: "पासवर्ड आवश्यक है।",
        ValConfPass: "पासवर्ड की पुष्टि करना आवश्यक है।",
        ValPassNotMatch: "पासवर्ड और पासवर्ड की पुष्टि मेल नहीं खाते",
        ValMemberId: "सदस्य आईडी आवश्यक है",
        ValCity: "शहर आवश्यक है",
        ValDob: "जन्म तिथि आवश्यक है",
        ValEnrollmentId: "पंजीकरण आईडी आवश्यक है",
        ValMember: "सदस्य आवश्यक है।",
        ValStartDate: "प्रारंभ तिथि आवश्यक है।",
        ValEndDate: "समापन तिथि आवश्यक है।",
        ValAmount: "राशि आवश्यक है।",
        ValDate: "तिथि आवश्यक है।",
        ValHeight: "ऊँचाई आवश्यक है।",
        ValWeight: "वजन आवश्यक है।",
        ValPaymentMethod: "भुगतान का तरीका आवश्यक है।",
        ValPaymentDate: "भुगतान तिथि आवश्यक है।",
        ValSubsType: "सदस्यता प्रकार आवश्यक है।",
        ValSubsPlan: "सदस्यता योजना आवश्यक है।",
        ValDueDate: "बकाया तिथि आवश्यक है।",
        ValOrgName: "संगठन का नाम आवश्यक है।",
        ValCountry: "देश आवश्यक है।",
        ValPhone: "फ़ोन आवश्यक है।",
        ValState: "राज्य आवश्यक है।",
        ValZip: "ज़िप कोड आवश्यक है।",
        ValAddress: "पता आवश्यक है।",
        ValDuration: "अवधि आवश्यक है।",
        ValFreeze: "फ्रीज आवश्यक है।",
        ValBranch: "शाखा आवश्यक है।",
        ValCurrency: "मुद्रा आवश्यक है।",
        DataNotAvaiable: "डेटा उपलब्ध नहीं है",

        invHaveMsg1: "आपके पास पहले से ही",
        invHaveMsg2:
          "सक्रिय चालान है। अभी आप चालान बना रहे हैं, आप इस चालान को समाप्त होने के बाद शुरू करेंगे।",

        Welcome: "स्वागत है",
        MyAccount: "मेरा खाता",
        Logout: "लॉगआउट",
      },
    },
    zh: {
      translation: {
        MemberScince: "会员自",
        PersonalDetails: "个人详情",
        Birthday: "生日",
        YearsOld: "岁",
        Search: "搜索",
        MakeMember: "创建会员",
        Dashboard: "仪表板",
        Inquiry: "查询",
        InquiryList: "查询列表",
        AddInquiry: "添加查询",
        Membership: "会员",
        MemberList: "会员列表",
        Member: "会员",
        AddMember: "添加会员",
        FreezeList: "冻结列表",
        AddFreeze: "添加冻结",
        MeasurementList: "测量列表",
        AddMeasurement: "添加测量",
        Payment: "付款",
        PaymentList: "付款列表",
        AddPayment: "添加付款",
        Invoice: "发票",
        CreateDate: "创建日期",
        CreateUser: "创建用户",
        PayNow: "立即支付",
        PaymentId: "付款ID",
        ViewFile: "查看文件",
        InvoiceList: "发票列表",
        AddInvoice: "添加发票",
        Attendance: "考勤",
        Master: "主控",
        UserList: "用户列表",
        AddUser: "添加用户",
        BranchList: "分支列表",
        AddBranch: "添加分支",
        City: "城市",
        CityList: "城市列表",
        Types: "类型",
        ZIP: "邮政编码",
        Language: "语言",
        FollowUpTypes: "跟进类型",
        FollowUpType: "跟进类型",
        DefaultBranch: "默认分支",
        SetDefaultBranch: "设置为默认分支",
        InquirySources: "查询来源",
        InquirySource: "查询来源",
        MemberStatus: "会员状态",
        SubmitAsADefaultBranch: "提交为默认分支",
        Organization: "组织",
        SubscriptionTypes: "订阅类型",
        SubscriptionPlans: "订阅计划",
        PaymentsThisMonth: "本月付款",
        Scheduled: "已安排",
        Paid: "已付款",
        Overdue: "逾期",
        Notification: "通知",
        Payments: "付款",
        Pending: "待定",
        Active: "活跃",
        Expired: "已过期",
        Total: "总计",
        In: "在",
        Out: "出",
        Due: "到期",
        NoPlan: "无计划",
        Date: "日期",
        Thumb: "指纹",
        InTime: "签到时间",
        ThumbId: "指纹ID",
        OutTime: "签出时间",
        UserId: "用户ID",
        ExpiresIn: "剩余有效期",
        Days: "天",
        LastVisit: "最后访问",
        LastPaid: "最后付款",
        Profile: "个人资料",
        FreezeMember: "冻结会员",
        UserDetails: "用户详情",
        Memeber: "会员",
        Contact: "联系",
        BillingStatus: "账单状态",
        MemberId: "会员ID",
        ChargeType: "收费类型",
        PackageName: "套餐名称",
        Amount: "金额",
        Freeze: "冻结",
        FreezeDate: "冻结日期",
        Age: "年龄",
        Height: "身高（英尺）",
        Weight: "体重（公斤）",
        PaymentMethod: "付款方式",
        ReferenceNo: "参考号码",
        PaymentDate: "付款日期",
        Status: "状态",
        IdFreeFreeze: "ID / 免费冻结",
        DueAmount: "到期金额",
        Subscription: "订阅",
        Duration: "持续时间",
        InvoiceId: "发票ID",
        PlanDate: "计划日期",
        Id: "ID",
        Visit: "访问",
        UploadFile: "上传文件",
        Package: "套餐",
        PayDate: "付款日期",
        Name: "姓名",
        Phone: "电话",
        Mobile: "手机",
        Gender: "性别",
        Nationality: "国籍",
        AlternateMobile: "备用手机",
        PrimaryAddress: "主要地址",
        SecondaryAddress: "次要地址",
        ProfilePhoto: "个人照片",
        IDProof: "身份证明",
        CivilId: "公民身份证",
        Remark: "备注",
        User: "用户",
        Username: "用户名",
        Branch: "分支",
        UserRole: "用户角色",
        Address: "地址",
        Country: "国家",
        AddedDate: "添加日期",
        LastUpdateDate: "最后更新日期",
        AddedUser: "添加用户",
        SubscriptionType: "订阅类型",
        SubscriptionPlan: "订阅计划",
        FreeFreeze: "免费冻结",
        InquirySourceName: "查询来源名称",
        SourceOfInquiry: "查询来源",
        InquiryDate: "查询日期",
        TypeName: "类型名称",
        InquiryId: "查询ID",
        Add: "添加",
        Added: "已添加",
        Edit: "编辑",
        Delete: "删除",
        Update: "更新",
        Actions: "操作",
        AddFollowUp: "添加跟进",
        AddFollowUpType: "添加跟进类型",
        FollowUpDate: "跟进日期",
        FollowUpTime: "跟进时间",
        Type: "类型",
        Note: "备注",
        FollowUp: "跟进",
        Successfully: "成功",
        Success: "成功",
        Cancel: "取消",
        Submit: "提交",
        Details: "详细信息",
        Discount: "折扣",
        Error: "错误",
        StopAccess: "停止访问",
        NetPay: "净付款",
        Warning: "警告",
        FreeFreezeCount: "免费冻结计数",
        InvoiceTitle: "发票标题",
        FollowType: "跟进类型",
        AddInquirySource: "添加查询来源",
        InquirySrouceName: "查询来源名称",
        GenerateMemberId: "生成会员ID",
        EnrollmentId: "报名ID",
        DateOfBirth: "出生日期",
        Loading: "加载中",
        UnfreezeMember: "解冻会员",
        View: "查看",
        State: "州",
        Measurement: "测量",
        Freezed: "已冻结",
        StartDate: "开始日期",
        EndDate: "结束日期",
        NotStartedYet: "尚未开始",
        WaveAmount: "波动金额",
        MemberDetails: "会员详情",
        PlanSubscribed: "订阅计划",
        PlanEndDate: "计划结束日期",
        Unfreeze: "解冻",
        Start: "开始",
        End: "结束",
        LeanMuscle: "瘦肌",
        Neck: "颈部",
        NavelPoint: "脐点",
        RArm: "右臂",
        LArm: "左臂",
        LNavelPoint: "左脐点",
        ThighL: "左大腿",
        ThighR: "右大腿",
        ShoulderRound: "肩膀（圆形）",
        Chest: "胸部",
        UpperAbs: "上腹部",
        UpperWaist: "上腰部",
        LowerWaist: "下腰部",
        LCalves: "左小腿",
        RCalves: "右小腿",
        BMI: "BMI",
        BMR: "BMR",
        VisceralFat: "内脏脂肪",
        SubcutaneousFat: "皮下脂肪",
        DoYouHave: "您是否有？",
        HeightFeet: "身高（英尺）",
        WeightKG: "体重（公斤）",
        CreateInvoice: "创建发票",
        DueDate: "截止日期",
        Title: "标题",
        Plan: "计划",
        PaidDate: "付款日期",
        Password: "密码",
        ConfirmPassword: "确认密码",
        Inactive: "不活跃",
        EditOrganizationDetails: "编辑组织详情",
        OrganizationName: "组织名称",
        LocaleOrgName: "本地组织名称",
        FreezeFees: "冻结费用",
        EnrollmentFees: "报名费用",
        TransferFees: "转账费用",
        MachineIP: "机器IP",
        ServerIP: "服务器IP",
        TaxNo: "税号",
        AUTOEMAILSEND: "自动邮件发送",
        BIOMETRIC_INTEGRATION: "生物识别集成",
        Logo: "徽标",
        SubmitDifBranch: "提交为默认分支",
        BranchDetails: "分支详情",
        BranchId: "分支ID",
        BranchName: "分支名称",
        Currency: "货币",
        FeezeFees: "冻结费用",
        Website: "网站",
        AutoEmailSend: "自动邮件发送",
        BiometricIntegration: "生物识别集成",
        Yes: "是",
        Ok: "确定",
        GeneralFields: "常规字段",
        AdditionalFields: "附加字段",
        SaveChanges: "保存更改",
        FirstName: "名字",
        LastName: "姓氏",
        Email: "电子邮件",
        AddStatus: "添加状态",
        AddPlan: "添加计划",
        AddCity: "添加城市",
        CfmTitle: "您确定吗",
        DltSuccessTitle: "已成功删除",
        MemberDltTitle: "您想要删除此会员吗？",
        FollowUpDltTitle: "您想要删除此跟进吗？",
        FollowUpTypeDltTitle: "您想要删除此类型吗？",
        InqDltTitle: "您想要删除此询问来源吗？",
        MemberStatusDltTitle: "您想要删除此会员状态吗？",
        MMAddTitle: "测量已成功添加。",
        MMDltTitle: "您想要删除此测量吗？",
        PaymentSuccessTitle: "您已成功支付。",
        InvSuccessTitle: "已成功创建发票。",
        InvDltTitle: "您想要删除此用户吗？",
        UserStatusChgMsg1: "您想要",
        UserStatusChgMsg2: "此用户吗？",
        OrgSuccessTitle: "组织数据已成功更新。",
        SubsPlanDltTitle: "您想要删除此订阅计划吗？",
        SubsTypeDltTitle: "您想要删除此订阅类型吗？",
        BranchDltTitle: "您想要删除此分支吗？",
        BranchDtlErrTitle: "您无法删除此分支，因为这是当前选择的分支。",
        BranchDltSuccessTitle: "已成功设置为默认分支",
        DltErrTitle: "出现问题，请重试。",
        CityDltTitle: "您想要删除此城市吗？",
        ValFollowUpDate: "需要跟进日期。",
        ValFollowUpTime: "需要跟进时间。",
        ValFollowUpType: "需要类型。",
        ValName: "需要姓名",
        ValFirstName: "需要名字",
        ValLastName: "需要姓氏",
        ValGender: "需要性别",
        ValMobile: "需要手机",
        ValEmail: "需要电子邮件",
        ValRole: "需要角色。",
        ValPass: "需要密码。",
        ValConfPass: "需要确认密码。",
        ValPassNotMatch: "密码和确认密码不匹配",
        ValMemberId: "需要会员ID",
        ValCity: "需要城市",
        ValDob: "需要出生日期",
        ValEnrollmentId: "需要报名ID",
        ValMember: "需要会员。",
        ValStartDate: "需要开始日期。",
        ValEndDate: "需要结束日期。",
        ValAmount: "需要金额。",
        ValDate: "需要日期。",
        ValHeight: "需要身高。",
        ValWeight: "需要体重。",
        ValPaymentMethod: "需要付款方式。",
        ValPaymentDate: "需要付款日期。",
        ValSubsType: "需要订阅类型。",
        ValSubsPlan: "需要订阅计划。",
        ValDueDate: "需要到期日期。",
        ValOrgName: "需要组织名称。",
        ValCountry: "需要国家。",
        ValPhone: "需要电话。",
        ValState: "需要州。",
        ValZip: "需要邮政编码。",
        ValAddress: "需要地址。",
        ValDuration: "需要持续时间。",
        ValFreeze: "需要冻结。",
        ValBranch: "需要分支。",
        ValCurrency: "需要货币。",
        invHaveMsg1: "您已经有",
        invHaveMsg2: "活动发票。您现在正在创建发票，您将在结束此发票后开始。",
        DataNotAvaiable: "数据不可用",
        Welcome: "欢迎",
        MyAccount: "我的帐户",
        Logout: "注销",
      },
    },
    bn: {
      translation: {
        MemberScince: "সদস্য হওয়া",
        PersonalDetails: "ব্যক্তিগত তথ্য",
        Birthday: "জন্মদিন",
        YearsOld: "বয়স",
        Search: "অনুসন্ধান",
        MakeMember: "সদস্য নির্মাণ করুন",
        Dashboard: "ড্যাশবোর্ড",
        Inquiry: "অনুসন্ধান",
        InquiryList: "অনুসন্ধান তালিকা",
        AddInquiry: "অনুসন্ধান যোগ করুন",
        Membership: "সদস্যতা",
        MemberList: "সদস্য তালিকা",
        Member: "সদস্য",
        AddMember: "সদস্য যোগ করুন",
        FreezeList: "ফ্রিজ তালিকা",
        AddFreeze: "ফ্রিজ যোগ করুন",
        MeasurementList: "মাপমিয়ান তালিকা",
        AddMeasurement: "মাপমিয়ান যোগ করুন",
        Payment: "পেমেন্ট",
        PaymentList: "পেমেন্ট তালিকা",
        AddPayment: "পেমেন্ট যোগ করুন",
        Invoice: "চালান",
        CreateDate: "তৈরির তারিখ",
        CreateUser: "তৈরি করেছেন",
        PayNow: "এখন পরিশোধ করুন",
        PaymentId: "পেমেন্ট আইডি",
        ViewFile: "ফাইল দেখুন",
        InvoiceList: "চালান তালিকা",
        AddInvoice: "চালান যোগ করুন",
        Attendance: "উপস্থিতি",
        Master: "মাস্টার",
        UserList: "ব্যবহারকারী তালিকা",
        AddUser: "ব্যবহারকারী যোগ করুন",
        BranchList: "শাখা তালিকা",
        AddBranch: "শাখা যোগ করুন",
        City: "শহর",
        CityList: "শহরের তালিকা",
        Types: "প্রকার",
        ZIP: "জিপ কোড",
        Language: "ভাষা",
        FollowUpTypes: "অনুসরণের প্রকার",
        FollowUpType: "অনুসরণের প্রকার",
        DefaultBranch: "ডিফল্ট শাখা",
        SetDefaultBranch: "ডিফল্ট শাখা সেট করুন",
        InquirySources: "অনুসন্ধানের উৎস",
        InquirySource: "অনুসন্ধানের উৎস",
        MemberStatus: "সদস্য অবস্থা",
        SubmitAsADefaultBranch: "ডিফল্ট শাখা হিসেবে জমা দিন",
        Organization: "প্রতিষ্ঠান",
        SubscriptionTypes: "সাবস্ক্রিপশন প্রকার",
        SubscriptionPlans: "সাবস্ক্রিপশন পরিকল্পনা",
        // Dashbaord
        PaymentsThisMonth: "এই মাসে পেমেন্ট",
        // Inner Text
        Scheduled: "নির্ধারিত",
        Paid: "পেইড",
        Overdue: "বিলম্বিত",
        Notification: "বিজ্ঞপ্তি",
        Payments: "পেমেন্টস",
        // Status
        Pending: "বিচারাধীন",
        Active: "সক্রিয়",
        Expired: "মেয়াদোত্তীর্ণ",
        Total: "মোট",
        In: "ইন",
        Out: "আউট",
        Due: "বকেয়া",
        NoPlan: "কোনো পরিকল্পনা নেই",
        Date: "তারিখ",
        Thumb: "বুদ্ধিমত্ত",
        InTime: "ইন সময়",
        ThumbId: "বুদ্ধিমত্ত আইডি",
        OutTime: "আউট সময়",
        UserId: "ব্যবহারকারী আইডি",
        ExpiresIn: "মেয়াদ উত্তীর্ণ হবে",
        Days: "দিন",
        LastVisit: "সর্বশেষ দর্শন",
        LastPaid: "সর্বশেষ পেইড",
        Profile: "প্রোফাইল",
        FreezeMember: "সদস্য ফ্রিজ",
        UserDetails: "ব্যবহারকারী বিবরণ",
        // Table Header
        Memeber: "সদস্য",
        Contact: "যোগাযোগ",
        BillingStatus: "বিল স্থিতি",
        MemberId: "সদস্য আইডি",
        ChargeType: "চার্জ প্রকার",
        PackageName: "প্যাকেজ নাম",
        Amount: "পরিমাণ",
        Freeze: "ফ্রিজ",
        FreezeDate: "ফ্রিজ তারিখ",
        Age: "বয়স",
        Height: "উচ্চতা (ফুট)",
        Weight: "ওজন (কেজি)",
        PaymentMethod: "পেমেন্ট পদ্ধতি",
        ReferenceNo: "রেফারেন্স নং",
        PaymentDate: "পেমেন্ট তারিখ",
        Status: "স্থিতি",
        IdFreeFreeze: "আইডি / ফ্রি ফ্রিজ",
        DueAmount: "বকেয়া পরিমাণ",
        Subscription: "সাবস্ক্রিপশন",
        Duration: "স্থিতি",
        InvoiceId: "চালান আইডি",
        PlanDate: "পরিকল্পনা তারিখ",
        Id: "আইডি",
        Visit: "দর্শন",
        UploadFile: "ফাইল আপলোড করুন",
        Package: "প্যাকেজ",
        PayDate: "পেই তারিখ",
        Name: "নাম",
        Phone: "ফোন",
        Mobile: "মোবাইল",
        Gender: "লিঙ্গ",
        Nationality: "জাতীয়তা",
        AlternateMobile: "আল্টারনেট মোবাইল",
        PrimaryAddress: "প্রাথমিক ঠিকানা",
        SecondaryAddress: "দ্বিতীয় ঠিকানা",
        ProfilePhoto: "প্রোফাইল ফটো",
        IDProof: "আইডি প্রুফ",
        CivilId: "সিভিল আইডি",
        Remark: "মন্তব্য",
        User: "ব্যবহারকারী",
        Username: "ব্যবহারকারীর নাম",
        Branch: "শাখা",
        UserRole: "ব্যবহারকারী ভূমিকা",
        Address: "ঠিকানা",
        Country: "দেশ",
        AddedDate: "যোগ করার তারিখ",
        LastUpdateDate: "সর্বশেষ আপডেট তারিখ",
        AddedUser: "যোগ করেছেন",
        SubscriptionType: "সাবস্ক্রিপশন প্রকার",
        SubscriptionPlan: "সাবস্ক্রিপশন পরিকল্পনা",
        FreeFreeze: "ফ্রি ফ্রিজ",
        InquirySourceName: "অনুসন্ধানের উৎসের নাম",
        SourceOfInquiry: "অনুসন্ধানের উৎস",
        InquiryDate: "অনুসন্ধানের তারিখ",
        TypeName: "প্রকারের নাম",
        InquiryId: "অনুসন্ধান আইডি",
        Add: "যোগ করুন",
        Added: "যোগ করা হয়েছে",
        Edit: "সম্পাদন করুন",
        Delete: "মুছে ফেলুন",
        Update: "আপডেট করুন",
        Actions: "ক্রিয়াকলাপ",
        AddFollowUp: "অনুসরণ যোগ করুন",
        AddFollowUpType: "অনুসরণের প্রকার যোগ করুন",
        FollowUpDate: "অনুসরণের তারিখ",
        FollowUpTime: "অনুসরণের সময়",
        Type: "প্রকার",
        Note: "মন্তব্য",
        FollowUp: "অনুসরণ",
        Successfully: "সফলভাবে",
        Success: "সাফল্য",
        Cancel: "বাতিল",
        Submit: "জমা দিন",
        Details: "বিবরণ",
        Discount: "ডিসকাউন্ট",
        Error: "ত্রুটি",
        StopAccess: "প্রবেশ বন্ধ করুন",
        NetPay: "নেট পেই",
        Warning: "সতর্কতা",
        FreeFreezeCount: "ফ্রি ফ্রিজ সংখ্যা",
        InvoiceTitle: "চালানের শিরোনাম",
        FollowType: "অনুসরণের প্রকার",
        AddInquirySource: "অনুসন্ধানের উৎস যোগ করুন",
        InquirySrouceName: "অনুসন্ধানের উৎসের নাম",
        GenerateMemberId: "সদস্য আইডি তৈরি করুন",
        EnrollmentId: "এনরোলমেন্ট আইডি",
        DateOfBirth: "জন্ম তারিখ",
        Loading: "লোড হচ্ছে",
        UnfreezeMember: "সদস্য অফুঁইজ",
        View: "দেখুন",
        State: "রাজ্য",
        Measurement: "মাপমিয়ান্ট",
        Freezed: "ফ্রিজড",
        StartDate: "শুরুর তারিখ",
        EndDate: "শেষের তারিখ",
        NotStartedYet: "এখনো শুরু হয়নি",
        WaveAmount: "তরঙ্গ পরিমাণ",
        MemberDetails: "সদস্যের বিবরণ",
        PlanSubscribed: "পরিকল্পনা সাবস্ক্রাইব করা হয়েছে",
        PlanEndDate: "পরিকল্পনা শেষের তারিখ",
        Unfreeze: "আপফ্রোজ",
        Start: "শুরু",
        End: "শেষ",
        LeanMuscle: "লিন মাসল",
        Neck: "গলা",
        NavelPoint: "নেভেল পয়েন্ট",
        RArm: "ডান বাংহ",
        LArm: "বাম বাংহ",
        LNavelPoint: "বাম নেভেল পয়েন্ট",
        ThighL: "বাম পায়ের মাংস",
        ThighR: "ডান পায়ের মাংস",
        ShoulderRound: "শোল্ডার (গোল)",
        Chest: "সিনার",
        UpperAbs: "আপার পেট",
        UpperWaist: "আপার কমর",
        LowerWaist: "নিম্ন কমর",
        LCalves: "বাম পা",
        RCalves: "ডান পা",
        BMI: "বিএমআই",
        BMR: "বিএমআর",
        VisceralFat: "ভিসারাল চর্বি",
        SubcutaneousFat: "সাবকাটেনিয়াস চর্বি",
        DoYouHave: "আপনার কি আছে?",
        HeightFeet: "উচ্চতা (ফুট)",
        WeightKG: "ওজন (কেজি)",
        CreateInvoice: "চালান তৈরি করুন",
        DueDate: "স্থিতি",
        Title: "শিরোনাম",
        Plan: "পরিকল্পনা",
        PaidDate: "পেইড তারিখ",
        Password: "পাসওয়ার্ড",
        ConfirmPassword: "পাসওয়ার্ড নিশ্চিত করুন",
        Inactive: "নিষ্ক্রিয়",
        EditOrganizationDetails: "প্রতিষ্ঠানের বিবরণ সম্পাদনা করুন",
        OrganizationName: "প্রতিষ্ঠানের নাম",
        LocaleOrgName: "লোকেল অর্গ. নাম",
        FreezeFees: "ফ্রিজ ফি",
        EnrollmentFees: "এনরোলমেন্ট ফি",
        TransferFees: "স্থানান্তর ফি",
        MachineIP: "মেশিন আইপি",
        ServerIP: "সার্ভার আইপি",
        TaxNo: "ট্যাক্স নং",
        AUTOEMAILSEND: "অটো ইমেল প্রেরণ",
        BIOMETRIC_INTEGRATION: "বায়োমেট্রিক ইন্টিগ্রেশন",
        Logo: "লোগো",
        SubmitDifBranch: "ডিফল্ট শাখা হিসেবে জমা দিন",
        BranchDetails: "শাখা বিবরণ",
        BranchId: "শাখা আইডি",
        BranchName: "শাখার নাম",
        Currency: "মুদ্রা",
        FeezeFees: "ফি ফি",
        Website: "ওয়েবসাইট",
        AutoEmailSend: "অটো ইমেল প্রেরণ",
        BiometricIntegration: "বায়োমেট্রিক ইন্টিগ্রেশন",
        Yes: "হ্যাঁ",
        Ok: "ঠিক আছে",
        // Form
        GeneralFields: "সাধারণ ক্ষেত্র",
        AdditionalFields: "অতিরিক্ত ক্ষেত্র",
        SaveChanges: "পরিবর্তন সংরক্ষণ করুন",
        FirstName: "প্রথম নাম",
        LastName: "শেষ নাম",
        Email: "ইমেল",
        AddStatus: "স্থিতি যোগ করুন",
        AddPlan: "পরিকল্পনা যোগ করুন",
        AddCity: "শহর যোগ করুন",
        // Alert
        CfmTitle: "আপনি কি নিশ্চিত",
        DltSuccessTitle: "সফলভাবে মুছে ফেলা হয়েছে",
        MemberDltTitle: "আপনি কি এই সদস্যকে মুছতে চান?",
        FollowUpDltTitle: "আপনি কি এই অনুসরণ মুছতে চান?",
        FollowUpTypeDltTitle: "আপনি কি এই প্রকার মুছতে চান?",
        InqDltTitle: "আপনি কি এই অনুসন্ধান উৎসটি মুছতে চান?",
        MemberStatusDltTitle: "আপনি কি এই সদস্য স্থিতিটি মুছতে চান?",
        MMAddTitle: "মাপমিয়ান সফলভাবে যোগ করা হয়েছে।",
        MMDltTitle: "আপনি কি এই মাপমিয়ান মুছতে চান?",
        PaymentSuccessTitle: "আপনি সফলভাবে পেই করেছেন।",
        InvSuccessTitle: "চালান সফলভাবে তৈরি হয়েছে।",
        InvDltTitle: "আপনি কি এই ব্যবহারকারীকে মুছতে চান?",
        UserStatusChgMsg1: "আপনি কি",
        UserStatusChgMsg2: "এই ব্যবহারকারীকে?",
        OrgSuccessTitle: "সংস্থার তথ্য সফলভাবে আপডেট হয়েছে।",
        SubsPlanDltTitle: "আপনি কি এই সাবস্ক্রিপশন পরিকল্পনা মুছতে চান?",
        SubsTypeDltTitle: "আপনি কি এই সাবস্ক্রিপশন প্রকারটি মুছতে চান?",
        BranchDltTitle: "আপনি কি এই শাখাটি মুছতে চান?",
        BranchDtlErrTitle:
          "আপনি এই শাখাটি মুছতে পারবেন না, কারন এটি এখন নির্বাচিত শাখা।",
        BranchDltSuccessTitle: "সফলভাবে ডিফল্ট শাখা হিসেবে সেট করা হয়েছে",
        DltErrTitle: "কিছু ভুল হয়েছে। দয়া করে আবার চেষ্টা করুন।",
        CityDltTitle: "আপনি কি এই শহরটি মুছতে চান?",
        // Validation Messanges
        ValFollowUpDate: "অনুসরণের তারিখ প্রয়োজন।",
        ValFollowUpTime: "অনুসরণের সময় প্রয়োজন।",
        ValFollowUpType: "প্রকার প্রয়োজন।",
        ValName: "নাম প্রয়োজন",
        ValFirstName: "প্রথম নাম প্রয়োজন",
        ValLastName: "শেষ নাম প্রয়োজন",
        ValGender: "লিঙ্গ প্রয়োজন",
        ValMobile: "মোবাইল প্রয়োজন",
        ValEmail: "ইমেল প্রয়োজন",
        ValRole: "ভূমিকা প্রয়োজন।",
        ValPass: "পাসওয়ার্ড প্রয়োজন।",
        ValConfPass: "পাসওয়ার্ড এবং পাসওয়ার্ড নিশ্চিত না মিলে",
        ValMemberId: "সদস্য আইডি প্রয়োজন",
        ValCity: "শহর প্রয়োজন",
        ValDob: "জন্ম তারিখ প্রয়োজন",
        ValEnrollmentId: "এনরোলমেন্ট আইডি প্রয়োজন",
        ValMember: "সদস্য প্রয়োজন।",
        ValStartDate: "শুরুর তারিখ প্রয়োজন।",
        ValEndDate: "শেষের তারিখ প্রয়োজন।",
        ValAmount: "পরিমাণ প্রয়োজন।",
        ValDate: "তারিখ প্রয়োজন।",
        ValHeight: "উচ্চতা প্রয়োজন।",
        ValWeight: "ওজন প্রয়োজন।",
        ValPaymentMethod: "পেমেন্ট পদ্ধতি প্রয়োজন।",
        ValPaymentDate: "পেমেন্ট তারিখ প্রয়োজন।",
        ValSubsType: "সাবস্ক্রিপশন প্রকার প্রয়োজন।",
        ValSubsPlan: "সাবস্ক্রিপশন পরিকল্পনা প্রয়োজন।",
        ValDueDate: "বাকি তারিখ প্রয়োজন।",
        ValOrgName: "অর্গ. নাম প্রয়োজন।",
        ValCountry: "দেশ প্রয়োজন।",
        ValPhone: "ফোন প্রয়োজন।",
        ValState: "রাজ্য প্রয়োজন।",
        ValZip: "জিপ প্রয়োজন।",
        ValAddress: "ঠিকানা প্রয়োজন।",
        ValDuration: "স্থিতি প্রয়োজন।",
        ValFreeze: "ফ্রিজ প্রয়োজন।",
        ValBranch: "শাখা প্রয়োজন।",
        ValCurrency: "মুদ্রা প্রয়োজন।",
        // Custome Messages
        invHaveMsg1: "আপনি ইতিমধ্যে",
        invHaveMsg2:
          "সক্রিয় চালান রয়েছে। এই চালান শেষ হওয়ার পরে আপনি চালান শুরু করতে পারবেন",
        DataNotAvaiable: "ডেটা উপলব্ধ নয়",
        Welcome: "স্বাগতম",
        MyAccount: "আমার অ্যাকাউন্ট",
        Logout: "লগআউট",
      },
    },
    fr: {
      translation: {
        MemberScince: "Membre depuis",
        PersonalDetails: "Détails personnels",
        Birthday: "Anniversaire",
        YearsOld: "ans",
        Search: "Rechercher",
        MakeMember: "Créer un membre",
        Dashboard: "Tableau de bord",
        Inquiry: "Enquête",
        InquiryList: "Liste des enquêtes",
        AddInquiry: "Ajouter une enquête",
        Membership: "Adhésion",
        MemberList: "Liste des membres",
        Member: "Membre",
        AddMember: "Ajouter un membre",
        FreezeList: "Liste des suspensions",
        AddFreeze: "Ajouter une suspension",
        MeasurementList: "Liste des mesures",
        AddMeasurement: "Ajouter une mesure",
        Payment: "Paiement",
        PaymentList: "Liste des paiements",
        AddPayment: "Ajouter un paiement",
        Invoice: "Facture",
        CreateDate: "Date de création",
        CreateUser: "Créer un utilisateur",
        PayNow: "Payer maintenant",
        PaymentId: "Identifiant de paiement",
        ViewFile: "Voir le fichier",
        InvoiceList: "Liste des factures",
        AddInvoice: "Ajouter une facture",
        Attendance: "Présence",
        Master: "Maître",
        UserList: "Liste des utilisateurs",
        AddUser: "Ajouter un utilisateur",
        BranchList: "Liste des succursales",
        AddBranch: "Ajouter une succursale",
        City: "Ville",
        CityList: "Liste des villes",
        Types: "Types",
        ZIP: "Code postal",
        Language: "Langue",
        FollowUpTypes: "Types de suivi",
        FollowUpType: "Type de suivi",
        DefaultBranch: "Succursale par défaut",
        SetDefaultBranch: "Définir la succursale par défaut",
        InquirySources: "Sources d'enquête",
        InquirySource: "Source d'enquête",
        MemberStatus: "Statut du membre",
        SubmitAsADefaultBranch: "Soumettre en tant que succursale par défaut",
        Organization: "Organisation",
        SubscriptionTypes: "Types d'abonnement",
        SubscriptionPlans: "Plans d'abonnement",
        // Dashbaord
        PaymentsThisMonth: "PAIEMENTS CE MOIS-CI",
        // Inner Text
        Scheduled: "Planifié",
        Paid: "Payé",
        Overdue: "En retard",
        Notification: "Notification",
        Payments: "Paiements",
        // Status
        Pending: "En attente",
        Active: "Actif",
        Expired: "Expiré",
        Total: "Total",
        In: "Dans",
        Out: "Hors",
        Due: "Dû",
        NoPlan: "Pas de plan",
        Date: "Date",
        Thumb: "Pouce",
        InTime: "Heure d'entrée",
        ThumbId: "Identifiant du pouce",
        OutTime: "Heure de sortie",
        UserId: "Identifiant de l'utilisateur",
        ExpiresIn: "Expire dans",
        Days: "Jours",
        LastVisit: "Dernière visite",
        LastPaid: "Dernier paiement",
        Profile: "Profil",
        FreezeMember: "Suspendre le membre",
        UserDetails: "Détails de l'utilisateur",
        // Table Header
        Memeber: "Membre",
        Contact: "Contact",
        BillingStatus: "Statut de facturation",
        MemberId: "Identifiant du membre",
        ChargeType: "Type de charge",
        PackageName: "Nom du forfait",
        Amount: "Montant",
        Freeze: "Suspendre",
        FreezeDate: "Date de suspension",
        Age: "Âge",
        Height: "Taille (pieds)",
        Weight: "Poids (KG)",
        PaymentMethod: "Moyen de paiement",
        ReferenceNo: "Numéro de référence",
        PaymentDate: "Date de paiement",
        Status: "Statut",
        IdFreeFreeze: "ID / Suspension gratuite",
        DueAmount: "Montant dû",
        Subscription: "Abonnement",
        Duration: "Durée",
        InvoiceId: "ID de facture",
        PlanDate: "Date du plan",
        Id: "ID",
        Visit: "Visite",
        UploadFile: "Télécharger le fichier",
        Package: "Forfait",
        PayDate: "Date de paiement",
        Name: "Nom",
        Phone: "Téléphone",
        Mobile: "Mobile",
        Gender: "Genre",
        Nationality: "Nationalité",
        AlternateMobile: "Mobile alternatif",
        PrimaryAddress: "Adresse principale",
        SecondaryAddress: "Adresse secondaire",
        ProfilePhoto: "Photo de profil",
        IDProof: "Preuve d'identité",
        CivilId: "ID civil",
        Remark: "Remarque",
        User: "Utilisateur",
        Username: "Nom d'utilisateur",
        Branch: "Succursale",
        UserRole: "Rôle de l'utilisateur",
        Address: "Adresse",
        Country: "Pays",
        AddedDate: "Date d'ajout",
        LastUpdateDate: "Dernière date de mise à jour",
        AddedUser: "Utilisateur ajouté",
        SubscriptionType: "Type d'abonnement",
        SubscriptionPlan: "Plan d'abonnement",
        FreeFreeze: "Suspendre gratuitement",
        InquirySourceName: "Nom de la source de l'enquête",
        SourceOfInquiry: "Source de l'enquête",
        InquiryDate: "Date de l'enquête",
        TypeName: "Nom du type",
        InquiryId: "ID de l'enquête",
        Add: "Ajouter",
        Added: "Ajouté",
        Edit: "Modifier",
        Delete: "Supprimer",
        Update: "Mettre à jour",
        Actions: "Actions",
        AddFollowUp: "Ajouter un suivi",
        AddFollowUpType: "Ajouter un type de suivi",
        FollowUpDate: "Date de suivi",
        FollowUpTime: "Heure de suivi",
        Type: "Type",
        Note: "Remarque",
        FollowUp: "Suivi",
        Successfully: "Avec succès",
        Success: "Succès",
        Cancel: "Annuler",
        Submit: "Soumettre",
        Details: "Détails",
        Discount: "Remise",
        Error: "Erreur",
        StopAccess: "Arrêter l'accès",
        NetPay: "Paiement net",
        Warning: "Avertissement",
        FreeFreezeCount: "Nombre de suspensions gratuites",
        InvoiceTitle: "Titre de la facture",
        FollowType: "Type de suivi",
        AddInquirySource: "Ajouter une source d'enquête",
        InquirySrouceName: "Nom de la source d'enquête",
        GenerateMemberId: "Générer l'identifiant du membre",
        EnrollmentId: "ID d'inscription",
        DateOfBirth: "Date de naissance",
        Loading: "Chargement",
        UnfreezeMember: "Décongeler le membre",
        View: "Voir",
        State: "État",
        Measurement: "Mesure",
        Freezed: "Suspendu",
        StartDate: "Date de début",
        EndDate: "Date de fin",
        NotStartedYet: "Pas encore commencé",
        WaveAmount: "MONTANT D'ONDE",
        MemberDetails: "Détails du membre",
        PlanSubscribed: "Plan souscrit",
        PlanEndDate: "Date de fin du plan",
        Unfreeze: "Décongeler",
        Start: "Démarrer",
        End: "Fin",
        LeanMuscle: "Masse maigre",
        Neck: "Cou",
        NavelPoint: "Point du nombril",
        RArm: "Bras droit",
        LArm: "Bras gauche",
        LNavelPoint: "Point du nombril gauche",
        ThighL: "Cuisse gauche",
        ThighR: "Cuisse droite",
        ShoulderRound: "Épaule (ronde)",
        Chest: "Poitrine",
        UpperAbs: "Haut des abdominaux",
        UpperWaist: "Taille supérieure",
        LowerWaist: "Taille inférieure",
        LCalves: "Mollets gauche",
        RCalves: "Mollets droit",
        BMI: "IMC",
        BMR: "MBR",
        VisceralFat: "Graisse viscérale",
        SubcutaneousFat: "Graisse sous-cutanée",
        DoYouHave: "Avez-vous?",
        HeightFeet: "Taille (pieds)",
        WeightKG: "Poids (KG)",
        CreateInvoice: "Créer une facture",
        DueDate: "Date d'échéance",
        Title: "Titre",
        Plan: "Plan",
        PaidDate: "Date de paiement",
        Password: "Mot de passe",
        ConfirmPassword: "Confirmer le mot de passe",
        Inactive: "Inactif",
        EditOrganizationDetails: "Modifier les détails de l'organisation",
        OrganizationName: "Nom de l'organisation",
        LocaleOrgName: "Nom de l'org. local",
        FreezeFees: "Frais de suspension",
        EnrollmentFees: "Frais d'inscription",
        TransferFees: "Frais de transfert",
        MachineIP: "IP de la machine",
        ServerIP: "IP du serveur",
        TaxNo: "Numéro de taxe",
        AUTOEMAILSEND: "ENVOI AUTOMATIQUE D'EMAIL",
        BIOMETRIC_INTEGRATION: "INTÉGRATION BIOMÉTRIQUE",
        Logo: "Logo",
        SubmitDifBranch: "Soumettre en tant que succursale par défaut",
        BranchDetails: "Détails de la succursale",
        BranchId: "Identifiant de la succursale",
        BranchName: "Nom de la succursale",
        Currency: "Devise",
        FeezeFees: "Frais de suspension",
        Website: "Site web",
        AutoEmailSend: "Envoi automatique d'e-mails",
        BiometricIntegration: "Intégration biométrique",
        Yes: "Oui",
        Ok: "D'accord",

        // Form
        GeneralFields: "Champs généraux",
        AdditionalFields: "Champs supplémentaires",
        SaveChanges: "Enregistrer les modifications",
        FirstName: "Prénom",
        LastName: "Nom de famille",
        Email: "E-mail",
        AddStatus: "Ajouter un statut",
        AddPlan: "Ajouter un plan",
        AddCity: "Ajouter une ville",

        // Alert
        CfmTitle: "Êtes-vous sûr",
        DltSuccessTitle: "Supprimé avec succès",
        MemberDltTitle: "Voulez-vous supprimer ce membre?",
        FollowUpDltTitle: "Voulez-vous supprimer ce suivi?",
        FollowUpTypeDltTitle: "Voulez-vous supprimer ce type?",
        InqDltTitle: "Voulez-vous supprimer cette source d'enquête?",
        MemberStatusDltTitle: "Voulez-vous supprimer ce statut de membre?",
        MMAddTitle: "Mesure ajoutée avec succès.",
        MMDltTitle: "Voulez-vous supprimer cette mesure?",
        PaymentSuccessTitle: "Vous avez payé avec succès.",
        InvSuccessTitle: "Facture créée avec succès.",
        InvDltTitle: "Voulez-vous supprimer cet utilisateur?",
        UserStatusChgMsg1: "Voulez-vous",
        UserStatusChgMsg2: "cet utilisateur?",
        OrgSuccessTitle: "Données de l'organisation mises à jour avec succès.",
        SubsPlanDltTitle: "Voulez-vous supprimer ce plan d'abonnement?",
        SubsTypeDltTitle: "Voulez-vous supprimer ce type d'abonnement?",
        BranchDltTitle: "Voulez-vous supprimer cette succursale?",
        BranchDtlErrTitle:
          "Vous ne pouvez pas supprimer cette succursale, car c'est la succursale sélectionnée actuellement.",
        BranchDltSuccessTitle: "Défini avec succès comme succursale par défaut",
        DltErrTitle: "Quelque chose ne va pas. Veuillez réessayer.",
        CityDltTitle: "Voulez-vous supprimer cette ville?",

        // Validation Messages
        ValFollowUpDate: "La date de suivi est requise.",
        ValFollowUpTime: "L'heure de suivi est requise.",
        ValFollowUpType: "Le type est requis.",
        ValName: "Le nom est requis",
        ValFirstName: "Le prénom est requis",
        ValLastName: "Le nom de famille est requis",
        ValGender: "Le genre est requis",
        ValMobile: "Le mobile est requis",
        ValEmail: "L'e-mail est requis",
        ValRole: "Le rôle est requis.",
        ValPass: "Le mot de passe est requis.",
        ValConfPass: "La confirmation du mot de passe est requise.",
        ValPassNotMatch:
          "Le mot de passe et la confirmation du mot de passe ne correspondent pas",
        ValMemberId: "L'identifiant du membre est requis",
        ValCity: "La ville est requise",
        ValDob: "La date de naissance est requise",
        ValEnrollmentId: "L'ID d'inscription est requis",
        ValMember: "Le membre est requis.",
        ValStartDate: "La date de début est requise.",
        ValEndDate: "La date de fin est requise.",
        ValAmount: "Le montant est requis.",
        ValDate: "La date est requise.",
        ValHeight: "La taille est requise.",
        ValWeight: "Le poids est requis.",
        ValPaymentMethod: "Le moyen de paiement est requis.",
        ValPaymentDate: "La date de paiement est requise.",
        ValSubsType: "Le type d'abonnement est requis.",
        ValSubsPlan: "Le plan d'abonnement est requis.",
        ValDueDate: "La date d'échéance est requise.",
        ValOrgName: "Le nom de l'org. est requis.",
        ValCountry: "Le pays est requis.",
        ValPhone: "Le téléphone est requis.",
        ValState: "L'état est requis.",
        ValZip: "Le code postal est requis.",
        ValAddress: "L'adresse est requise.",
        ValDuration: "La durée est requise.",
        ValFreeze: "La suspension est requise.",
        ValBranch: "La succursale est requise.",
        ValCurrency: "La devise est requise.",
        DataNotAvaiable: "Données non disponibles",
        // Custom Messages
        invHaveMsg1: "Vous avez déjà",
        invHaveMsg2:
          "une facture active. Actuellement, vous créez une facture, vous commencerez après la fin de cette facture.",
        Welcome: "Bienvenue",
        MyAccount: "Mon compte",
        Logout: "Déconnexion",
      },
    },
    // Add translations for other languages as needed
  },
});

export default i18n;
